import { createContext, useContext, useState, ReactNode } from "react"

type RedirectPaymentContextType = {
  isRedirectingToPayment: boolean
  startRedirect: () => void
  stopRedirect: () => void
}

const RedirectPaymentContext = createContext<RedirectPaymentContextType | null>(null)

export function RedirectPaymentProvider({ children }: { children: ReactNode }) {
  const [isRedirectingToPayment, setIsRedirectingToPayment] = useState(false)

  const startRedirect = () => setIsRedirectingToPayment(true)

  const stopRedirect = () => setIsRedirectingToPayment(false)

  return (
    <RedirectPaymentContext.Provider value={{ isRedirectingToPayment, startRedirect, stopRedirect }}>
      {children}
    </RedirectPaymentContext.Provider>
  )
}

export function useRedirectPayment() {
  const context = useContext(RedirectPaymentContext)

  if (!context) {
    throw new Error("useRedirectPayment must be used inside RedirectPaymentProvider")
  }

  return context
}
